<div class="row">
  <div class="col-md-6 mx-auto text-center">
    <bodyanalytics-empty-state class="mt-3" [icon]="icon()" [heading]="heading()" [message]="message()">
      @if (ctaLabel() && ctaLink()) {
        <a [routerLink]="ctaLink()" empty-action class="btn btn-primary">{{ ctaLabel() }}</a>
      }
    </bodyanalytics-empty-state>
  </div>
</div>
